import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import '../../CSS/TermsModal.css';
const TermsAndConditionModal = ({ isOpen, toggle }) => {
  const prohibited = [
    'Content that boasts, praises or promotes past, present, or future crimes',
    'Unnecessary graphic details of crimes',
    "Yours or anyone else's legal paperwork including court documents, victim documents or official documents from government agencies",
    'Admissions of guilt for crimes you have not been convicted of',
    'Names of individuals other than yourself or the loved one you are speaking on behalf of',
    'Individual personal addresses of you or anyone else',
    'Names of victims, co-defendants, witnesses or perpetrators, nor names of specific correctional officers',
    'Content that encourages aggressive / angry words or actions directed at public officials, officers of the court, correctional officers, judges or any employee of the state',
    'Gang names, symbols, flags, logos or gestures',
    'Content that ridicules victims or their families',
    'Firearms or weapons of any kind including ammunition and / or accessories',
    'Content that depicts or promotes the usage of drugs and / or alcohol',
    'Content that solicits money or financial assistance for you, your loved one or anyone at all',
    'Content that expresses, insinuates, or hints at the guilt of non-convicted citizens',
    'Explicit language',
    'Violent threats against any individual or entity of any kind',
    'Nudity or obscenity',
    'Content that equates to conspiracy theories',
    'Misinformation, lies or half-truths',
    'Personal medical records of you or anyone else',
    'Personal identity information such as bank account details, social security numbers, drivers license or any other sensitive content of similar nature',
    'Personal login codes, usernames or passwords for you or anyone else',
    "Content that violates or infringes on someone else's legally held copyright, trademark, intellectual property or patent",
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle} fullscreen className="terms-modal-wrapper">
      <div className="terms-modal-header">
        <div className="terms-header-inner">
          <span className="terms-header-eyebrow">6BY7 Platform</span>
          <span className="terms-header-title">Terms &amp; Conditions</span>
        </div>
      </div>

      <ModalBody className="terms-modal-body" id="printTermsOfUse">
        {/* Intro Section */}
        <section className="terms-section">
          <div className="terms-section-label">
            <span className="terms-label-dot" />
            Overview
          </div>
          <h2 className="terms-section-heading">Content-Share Guidelines &amp; Privacy Policy</h2>
          <p className="terms-paragraph">
            4DSPS is created in the spirit of peaceful civic engagement. We do not permit the use of
            bigoted language, anti-government or anti-law enforcement rhetoric or the provocation of
            violence of any kind. 4DSPS bears no tolerance for objectionable content or abusive
            users. We reserve the right to not post any content that we deem inappropriate or
            subversive to the spirit of our platform.
          </p>
        </section>

        {/* Prohibited Content */}
        <section className="terms-section">
          <div className="terms-section-label">
            <span className="terms-label-dot terms-label-dot--warn" />
            Prohibited Content
          </div>
          <h2 className="terms-section-heading">Do Not Post, Upload, Stream, or Share</h2>

          <ul className="terms-list">
            {prohibited.map((item, i) => (
              <li key={i} className="terms-list-item">
                <span className="terms-list-icon">✕</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Content Integrity */}
        <section className="terms-section">
          <div className="terms-section-label">
            <span className="terms-label-dot" />
            Standards
          </div>
          <h2 className="terms-section-heading">Content Integrity</h2>

          <div className="terms-integrity-cards">
            <div className="terms-card">
              <div className="terms-card-icon">◈</div>
              <p className="terms-paragraph">
                4DSPS expects every content-share to contain authentic stories of truthfulness and
                honesty without lies, fabrications or exaggerations.
              </p>
            </div>
            <div className="terms-card">
              <div className="terms-card-icon">◈</div>
              <p className="terms-paragraph">
                4DSPS is not responsible for stories or details within a story that may turn out to
                be falsified by the content-sharer.
              </p>
            </div>
            <div className="terms-card">
              <div className="terms-card-icon">◈</div>
              <p className="terms-paragraph">
                4DSPS reserves the right to inquire with family, friends, law enforcement and
                policymakers about the truthfulness of your story. If 4DSPS discovers that any part
                of your story is false, your account will be suspended and your posted content will
                be removed permanently.
              </p>
            </div>
          </div>
        </section>

        {/* Last Updated */}
        <div className="terms-updated">
          Last Updated: <strong>September 19, 2025</strong>
        </div>
      </ModalBody>

      <ModalFooter className="terms-modal-footer">
        <button className="terms-close-btn" onClick={toggle}>
          I Understand &amp; Accept
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default TermsAndConditionModal;
